import { Link } from "react-router-dom";

interface PageBannerProps {
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  current: string;
}

export default function PageBanner({
  eyebrow,
  title,
  description,
  image,
  imageAlt,
  current,
}: PageBannerProps) {
  return (
    <section className="relative flex h-[360px] w-full items-end overflow-hidden md:h-[440px]">
      <img
        src={image}
        alt={imageAlt}
        title={`${title} 동우스톤 석재 인테리어`}
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/55 to-foreground-950/45" />
      <div className="relative z-10 mx-auto w-full max-w-content px-4 pb-10 md:px-6 md:pb-14">
        <nav aria-label="현재 위치" className="flex flex-wrap items-center gap-2 text-xs text-background-200/80">
          <Link to="/" className="cursor-pointer transition-colors hover:text-background-50">
            홈
          </Link>
          <span>/</span>
          <span className="text-background-50">{current}</span>
        </nav>
        <p className="mt-5 font-label text-xs font-semibold tracking-[0.28em] text-primary-200">{eyebrow}</p>
        <h1 className="mt-3 font-heading text-4xl text-background-50 md:text-5xl">{title}</h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">{description}</p>
      </div>
    </section>
  );
}